import React from 'react'
import './SearchBox.scss'
import { CiSearch } from 'react-icons/ci'
import { IoFilter } from 'react-icons/io5'

const SearchBox = ({ placeholder, value, onChange, _function = null }) => {
  return (
    <div className='my-4 relative flex flex-row items-center rounded-lg px-3 py-1 w-full'>
      <CiSearch className='searchIcon' />
      <input
        className='form-input search-input'
        placeholder={placeholder ?? "Search for Branch Name"}
        type="text"
        value={value ?? ""}
        onChange={(e) => onChange?.(e.target.value)}
      />
      {value?.length > 0 && (
        <button
          type="button"
          onClick={() => onChange?.("")}
          className="ml-2 text-xs text-gray-500"
          title="Clear"
        >
          ×
        </button>
      )}
      <div onClick={() => (_function ? _function() : null)} className='ml-4 cursor-pointer'>
        <IoFilter />
      </div>
    </div>
  )
}

export default SearchBox
